import React from "react"
import Img from "gatsby-image"

const ContactCard = ({
  fixed,
  name,
  jobTitle,
  phone,
  extension,
  email,
  key,
}) => {
  return (
    <div
      className="grid  md:flex md:flex-row xl:max-w-6xl gap-x-8 bg-white  rounded-md p-10 my-5"
      key={key}
    >
      {fixed && (
        <div style={{ width: 200, justifySelf: "center" }}>
          <Img fixed={fixed} className=" rounded-full" />
        </div>
      )}
      <div className="flex flex-col   justify-left md:justify-start text-center md:text-left text-blue-dark">
        <ContactSubTitle color="red-800">{name}</ContactSubTitle>
        <ContactSubItem>{jobTitle}</ContactSubItem>
        <ContactSubItem>
          {phone}{" "}
          {extension && (
            <>
              &nbsp;&nbsp;
              <span className=" italic">ext.{extension}</span>
            </>
          )}
        </ContactSubItem>
        <ContactSubItem>
          <a
            className="hover:text-blue-light underline"
            href={`mailto:${email}`}
          >
            {email}
          </a>
        </ContactSubItem>
      </div>
    </div>
  )
}

// Utility components for the Contact Page

const CardsContainer = ({ children }) => (
  <div className="flex flex-wrap justify-center gap-x-8  mx-10">{children}</div>
)

const ContactSubItem = ({ children, className }) => (
  <p className={`mb-0 ${className}`}>{children}</p>
)

const ContactTitle = ({ children, className }) => (
  <h1 className={`text-center  ${className} text-5xl `}>{children}</h1>
)
const ContactSubTitle = ({ children, color = "blue-dark" }) => (
  <h2 className={`pb-0 text-4xl text-${color}`}>{children}</h2>
)

const ContactSubContainer = ({ children, className }) => {
  return (
    <div
      className={`grid gap-x-5 relative mb-10 ${className}`}
      style={{ gridTemplateColumns: "auto 1fr" }}
    >
      {children}
    </div>
  )
}

const ContactIconContainer = ({ children }) => (
  <div className="pt-5">{children}</div>
)

export {
  ContactSubItem,
  ContactTitle,
  ContactSubContainer,
  ContactIconContainer,
  ContactSubTitle,
  ContactCard,
  CardsContainer,
}
